module.exports = __webpack_public_path__ + "static/media/flight_ticket.3eefdcf7.svg";